import { useUrlDrawer } from "@nimble/react-state-hooks/use-url-drawer";
import React, { useCallback } from "react";

import JobDetailsDrawer from "@/components/shared/jobs/job-details-drawer/job-details-drawer.container";

export default function useJobDetailsURLDrawer() {
  const { isOpen, openDrawer, closeDrawer, value } = useUrlDrawer({
    paramName: "job",
  });

  const openJobDetailsDrawer = useCallback(
    (jobId: string, schoolNcesId: string) => {
      openDrawer(`${schoolNcesId}/${jobId}`);
    },
    [openDrawer],
  );

  let content = null;

  if (isOpen && value) {
    const [schoolNcesId, jobId] = value.split("/") as [string, string];

    content = (
      <JobDetailsDrawer
        jobId={jobId}
        schoolNcesId={schoolNcesId}
        onClose={closeDrawer}
      />
    );
  }

  return {
    isOpen: isOpen,
    content: content,
    openJobDetailsDrawer,
    closeJobDetailsDrawer: closeDrawer,
  };
}
